module.exports = __webpack_public_path__ + "img/Recurso 13.2988d75b.png";